import { render, staticRenderFns } from "./Menu.component.html?vue&type=template&id=07956ab0&scoped=true&"
import script from "./Menu.component.ts?vue&type=script&lang=ts&"
export * from "./Menu.component.ts?vue&type=script&lang=ts&"
import style0 from "./Menu.component.scss?vue&type=style&index=0&id=07956ab0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07956ab0",
  null
  
)

export default component.exports